var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "gg-card",
    [
      _c("gg-card-header", [
        _vm._v(" Manage Addon Domains "),
        _c(
          "div",
          {
            staticClass: "float-right"
          },
          [
            _c("gg-text-field", {
              attrs: {
                outlined: "",
                "append-icon": "mdi-magnify",
                "single-line": "",
                "hide-details": ""
              },
              model: {
                value: _vm.search,
                callback: function callback($$v) {
                  _vm.search = $$v
                },
                expression: "search"
              }
            })
          ],
          1
        )
      ]),
      _c(
        "gg-card-text",
        [
          _c("v-data-table", {
            attrs: {
              loading: _vm.loading,
              headers: _vm.headers,
              search: _vm.search,
              items: _vm.hostingAddonDomains
            },
            scopedSlots: _vm._u([
              {
                key: "item.actions",
                fn: function fn(_ref) {
                  var item = _ref.item
                  return [
                    _c(
                      "gg-btn",
                      {
                        on: {
                          click: function click($event) {
                            return _vm.openModal(item)
                          }
                        }
                      },
                      [_vm._v(" Delete ")]
                    )
                  ]
                }
              }
            ])
          }),
          _vm.modal
            ? _c("delete-addon-domain-modal", {
                attrs: {
                  opened: _vm.modal,
                  "addon-domain": _vm.selectedAddon
                },
                on: {
                  "addondomain-deleted": _vm.reload,
                  close: function close($event) {
                    return _vm.closeModal("delete")
                  }
                }
              })
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }